export type AsyncFunction<InputType, SyncRetVal> = (
  inputs: InputType
) => Promise<SyncRetVal>;

export const ASYNC_TIMEOUT_MS = 10_000;
